import { CSSProperties } from 'react';
import { css } from 'styled-components';

export interface WithPositionProps {
  position?: CSSProperties['position'];
  top?: CSSProperties['top'];
  right?: CSSProperties['right'];
  bottom?: CSSProperties['bottom'];
  left?: CSSProperties['left'];
  float?: CSSProperties['float'];
  alignSelf?: CSSProperties['alignSelf'];
}

// top, right, bottom, and left are ignored unless position is also supplied
export const withPositionCSS = ({
  position,
  top,
  right,
  bottom,
  left,
  float,
  alignSelf,
}: WithPositionProps) => css`
  ${
    position &&
    `
      position: ${position};

      ${top && `top: ${top}`};
      ${right && `right: ${right}`};
      ${bottom && `bottom: ${bottom}`};
      ${left && `left: ${left}`};
      ${float && `float: ${float}`};
    `
  }

  ${alignSelf && `align-self: ${alignSelf};`}
`;
